// Generated by purs version 0.14.5
"use strict";
var wheel = "wheel";
module.exports = {
    wheel: wheel
};
